import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/totalRevenueSalesSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import DatePicker from "./smartComponents/datePicker";
import PeriodType from "./smartComponents/periodType";
import IncludeReturns from "./smartComponents/includeReturns";
import ShowExpenses from "./smartComponents/showExpenses";
import CustomDateRanges from "./smartComponents/customDateRanges";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import ViewFilter, { totalRevenueViewOptions } from "../ViewFilter";
import PredictionToggle from "./smartComponents/PredictionToggle";
import PredictionChart from "./smartComponents/PredictionChart";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import "./totalRevenueSalesModule.scss";

function TotalRevenueSalesModule(props) {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.totalRevenueSales.isLoading);
  const initialRequest = useSelector((state) => state.totalRevenueSales.initialRequest);
  const currencySymbol = useSelector((state) => state.commonReducer.commonProps.currencySymbol);

  const { includeReturns = "", showExpenses = "" } = useSelector(
    (state) => state.totalRevenueSales.filters.toggles
  );
  const selectedRevenueView = useSelector((state) => state.totalRevenueSales.selectedRevenueView);
  const isRevenueCategoryView = selectedRevenueView?.id === "revenue_category";
  const showPrediction = useSelector((state) => state.totalRevenueSales.showPrediction);

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  return (
    <div id="total-revenue-sales-root">
      <SectionToggle
        autoHeight
        height={690}
        title="Total Revenue by"
        customClass="total-revenue-sales-section"
        isLoading={isLoading}
        learnMore={
          <>
            <ViewFilter
              stateKey="totalRevenueSales"
              updateRevenueView={actionCreators.updateRevenueView}
              options={totalRevenueViewOptions}
            />
            <KBLearnMore
              title="Total Revenue"
              description="This report shows all collected revenue across Services, Products, and Recurring billing for the selected timeframe. These insights help you understand overall financial performance, evaluate revenue trends, and forecast with greater accuracy."
              kbUrl={ILEARN_URLS.salesRevenue.totalRevenue}
            />
          </>
        }
        content={
          <>
            <div>
              <div id="override-edit-selection-bar" className="edit-selections-bar">
                <div className="top-filter">
                  <div>
                    <div>
                      {includeReturns && (
                        <div className="select-box-no-width">
                          <p>{includeReturns.label}</p>
                          <IncludeReturns label={includeReturns.label} />
                        </div>
                      )}

                      {showExpenses && isRevenueCategoryView && (
                        <div className="select-box-no-width">
                          <p>{showExpenses.label}</p>
                          <ShowExpenses label={showExpenses.label} />
                        </div>
                      )}

                      {isRevenueCategoryView && <PredictionToggle />}
                    </div>
                  </div>
                  {!showPrediction && (
                    <div className="top-right-filter">
                      <div className="select-box-no-width">
                        <p>Period Type</p>
                        <PeriodType />
                      </div>
                      <div className="select-box-no-width date-range-select-box">
                        <p>Date Range</p>
                        <CustomDateRanges />
                      </div>

                      <div className="date-select-box select-box-no-width multi">
                        <p>Date</p>
                        <DatePicker />
                      </div>
                      <UpdateBtns />
                    </div>
                  )}
                </div>
              </div>
              {!showPrediction && (
                <div className="chart-root">
                  <TableOrStackedBarChart currencySymbol={currencySymbol} />
                </div>
              )}

              {isRevenueCategoryView && showPrediction && (
                <div className="chart-root">
                  <PredictionChart />
                </div>
              )}
            </div>
          </>
        }
      />
    </div>
  );
}

export default memo(TotalRevenueSalesModule);
